const trackSearchEvent = (keyword) => {
  var _a;
  window.track("siteSearch", {
    params: "{}",
    keywords: keyword
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "view_search_results",
    content_keyword: keyword
  });
};

export { trackSearchEvent };
